import { shellStringResources } from '../Resources/ShellStringResources';
import { IRadioOption } from '../interfaces/IRadioOption';
import { ISelectOption } from '../interfaces/ISelectOption';

export const writeBehaviorOptionValues = {
    insert: 'insert',
    upsert: 'upsert',
    merge: 'merge',
    upload: 'upload',
    update: 'update',
    storedProcedure: 'storedProcedure',
    SCD2: 'SCD2',
};
export type writeBehaviorOptionValueTyping = typeof writeBehaviorOptionValues[keyof typeof writeBehaviorOptionValues];

export const writeBehaviorAllOptions: Array<ISelectOption<string>> = [
    {
        label: shellStringResources.WriteBehavior_Option_Insert,
        value: writeBehaviorOptionValues.insert
    },
    {
        label: shellStringResources.WriteBehavior_Option_Upsert,
        value: writeBehaviorOptionValues.upsert
    },
    {
        label: shellStringResources.MergeLabel,
        value: writeBehaviorOptionValues.merge
    },
    {
        label: shellStringResources.WriteBehavior_Option_Upload,
        value: writeBehaviorOptionValues.upload
    },
    {
        label: shellStringResources.Update,
        value: writeBehaviorOptionValues.update
    }
];

export const writeBehaviorRadioOptions: Array<IRadioOption<string>> = [
    {
        label: shellStringResources.WriteBehavior_Option_Insert,
        value: writeBehaviorOptionValues.insert
    },
    {
        label: shellStringResources.WriteBehavior_Option_Upsert,
        value: writeBehaviorOptionValues.upsert
    },
    {
        label: shellStringResources.StoredProcedure,
        value: writeBehaviorOptionValues.storedProcedure
    }
];

/**
 * Update method for Copy Job
 */
export enum UpdateMethod {
    Append = 'Append',
    Overwrite = 'Overwrite',
    Upsert = 'Upsert',
    Replace = 'Replace',
    Merge = 'Merge',
    SCD2 = 'SCD2'
}

export type UpdateMethodType = `${UpdateMethod}`;
